import
{
  Container,
  StyledCard,
  RecommendedContainer,
  RecommendedText,
  StyledCardContent,
  StyledCardActions,
  IconAvatarContainer,
  FeatureLinesContainer,
} from './AddonCard.styles';
import IconAvatar from '../../Avatars/IconAvatar/IconAvatar';
import AddonCardTitle from '../../Typography/AddonCardTitle/AddonCardTitle';
import FeatureLine from '../../Typography/FeatureLine/FeatureLine';
import OutlinedButton from '../../Buttons/OutlinedButton/OutlinedButton';
import SolidButton from '../../Buttons/SolidButton/SolidButton';
import StatusPill from '../../Pills/StatusPill/StatusPill';
import { Box, Stack } from '@mui/material';
import Title from '../../Typography/Title/Title';
import AddonCardPrices from '../../Typography/AddonCardPrices/AddonCardPrices';

const AddonCard = ({

  details,
  key,
  title,
  image,
  description,
  showDetails,
  isSelected,
  isActive,
  onClick,
  onSubscribeClick,
  isWide
}) =>
{
  const getButtonText = () =>
  {
    if (isSelected !== undefined)
    {
      return isSelected ? "Selected" : "Select";
    }
    return "Select";
  };

  return (

    <StyledCard selected={isSelected} active={isActive} onClick={onClick}>
      <StyledCardContent>
        <AddonCardTitle text={title} />
        <img src={image}
          width="100%" alt=""/>
        {showDetails &&
          description}
      </StyledCardContent>
      {showDetails &&
        <StyledCardActions>
          <Stack direction="column" spacing="1em" sx={{ width: "100%", padding: "1em" }}>
            <AddonCardPrices
              monthlyClubPrice={details.monthlyClubPrice}
              yearlyClubPrice={details.yearlyClubPrice}>
            </AddonCardPrices>
            {
              isActive &&
              <StatusPill
                text={'Active'}
                isActive
              />
            }
            {
              isSelected && !isActive &&
              <SolidButton
                text="Subscribe"
                onClick={onClick}
              />
            }
            {
              !isActive && !isSelected &&
              <Stack direction="row" justifyContent="center" spacing={1} sx={{ width: "100%" }}>
                <OutlinedButton
                  text="Subscribe"
                  onClick={() => { onSubscribeClick(details.name) }}
                  fullWidth
                />
              </Stack>
            }
          </Stack>
        </StyledCardActions>
      }
    </StyledCard>

  );
};

export default AddonCard;
